import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  makeStyles
} from "@material-ui/core";

import VehicleTrailerEditorSelect from "./VehicleTrailerEditorSelect";

const useStyles = makeStyles(({ spacing }) => ({
  paper: {
    width: spacing(50),
    height: spacing(60)
  }
}));

const VehicleTrailerEditor = ({
  trailer: initialTrailer,
  isOpen,
  onClose,
  onSubmit
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [trailer, setTrailer] = useState(initialTrailer);

  const handleTrailerChange = value => setTrailer(value);

  const handleSubmitButtonClick = () => {
    if (onSubmit) {
      onSubmit(trailer);
    }
  };

  useEffect(() => {
    setTrailer(initialTrailer);
  }, [isOpen]);

  return (
    <Dialog
      classes={{
        paper: classes.paper
      }}
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle>
        {t("webapp:vehicle.title.assign-trailer")}
      </DialogTitle>
      <VehicleTrailerEditorSelect value={trailer} onChange={handleTrailerChange} />
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {t("webapp:common.title.cancel")}
        </Button>
        <Button color="primary" onClick={handleSubmitButtonClick}>
          {t("webapp:common.title.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VehicleTrailerEditor;
